import { render, staticRenderFns } from "./AmcPage.vue?vue&type=template&id=2a89b4f2&scoped=true"
import script from "./AmcPage.vue?vue&type=script&lang=js"
export * from "./AmcPage.vue?vue&type=script&lang=js"
import style0 from "./AmcPage.vue?vue&type=style&index=0&id=2a89b4f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a89b4f2",
  null
  
)

export default component.exports